import { render, staticRenderFns } from "./bogus_detail.vue?vue&type=template&id=b30437ce&scoped=true&"
import script from "./bogus_detail.vue?vue&type=script&lang=js&"
export * from "./bogus_detail.vue?vue&type=script&lang=js&"
import style0 from "./bogus_detail.vue?vue&type=style&index=0&id=b30437ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30437ce",
  null
  
)

export default component.exports